import { Link, useRouter } from "@tanstack/react-router";

interface NavLinkProps {
    children: React.ReactNode;
    isActive?: boolean;
    to?: string;
    variant?: 'default' | 'mobile';
}

const NavLink = ({ children, isActive, to, variant = 'default' }: NavLinkProps) => {
    const router = useRouter();
    const currentPath = router.state.location.pathname;

    // If isActive is explicitly provided, use it; otherwise, check if current path matches the link
    const isLinkActive = isActive !== undefined ? isActive : (to && currentPath === to);

    const baseClasses = variant === 'mobile'
        ? 'block w-full px-3 py-2.5 rounded-lg text-lg transition-colors relative'
        : 'inline-block rounded-lg px-1.5 py-1.5 text-base font-medium transition-colors hover:cursor-pointer lg:px-3 lg:text-lg relative';
    const activeClasses = variant === 'mobile'
        ? 'bg-violet-50 text-violet-700 font-semibold'
        : 'text-slate-900 font-semibold';
    const inactiveClasses = variant === 'mobile'
        ? 'text-slate-600 hover:text-violet-700 hover:bg-violet-50'
        : 'text-slate-500 hover:text-slate-900 hover:bg-slate-50';

    return (
        <Link
            to={to || ''}
            aria-current={isLinkActive ? 'page' : undefined}
            className={`${baseClasses} ${isLinkActive ? activeClasses : inactiveClasses}`}
        >
            {children}
            {variant === 'default' && isLinkActive && (
                <span className="absolute -bottom-0.5 left-2 right-2 h-0.5 bg-violet-600 rounded-full"></span>
            )}
        </Link>
    );
};

export default NavLink;
